import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@upmc/ims.component-library';

import * as actions from '../../../../store/apps/actions';
import Icon from '../../../UI/MDC/Icon/Icon';

const ExpandingComponentContainerList = props => {
	const numContainers = useSelector(state => state.apps.numContainers);
	const { componentId, appId } = props;
	const dispatch = useDispatch();

	const onClickHandler = payload => {
		dispatch(
			actions.addNewContainer({
				appId: appId,
				componentKey: componentId,
			})
		);
	};

	useEffect(() => {
		const event = {
			target: {
				id: props.componentId,
				name: props.name,
				value: numContainers,
				elementType: 'containerlist',
			},
		};
		props.onChange(event, false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numContainers]);

	return (
		<div>
			<Button
				variant='outlined'
				onClick={payload => onClickHandler(payload)}
				endIcon={<Icon icon='add' />}
			>
				{'Add New ' + props.label}
			</Button>
		</div>
	);
};

export default ExpandingComponentContainerList;
